import OBTSnackbar from './OBTSnackbar';
export default OBTSnackbar;